import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJUtil from '../../../../util/FJUtil';
import { MOUSE_EVENT_TYPE } from '../../../FJMainPreview/FJCreationEditPanel/js/FJViewCanvas';
import { useCallback, memo, useMemo } from 'react';
import FJActionBrushEditCommon from '../../../../redux/action/FJActionBrushEditCommon';
import FJQuickSelectionBox from '../../../../common/components/FJQuickSelectionBox/FJQuickSelectionBox';
import FJConfig from '../../../../config/FJConfig';

const FJPhotoRemoveBgQuickSelectionBoxContainer = memo(function FJPhotoRemoveBgQuickSelectionBoxContainer() {
    useLocalStore();

    const dispatch = useDispatch();
    const curBrushType = useSelector(state => state.brushEditCommon.curBrushType);
    const isMove = useSelector(state => state.brushEditCommon.isMouseMove);
    const isDisabled = useSelector(state => FJUtil.isGeneratingStatus(state.common.taskStatus));
    const aiMaskActive = useSelector(state => state.brushEditCommon.aiMaskActive);

    const quickSelectionSelect = useMemo(() => {
        return !isMove && curBrushType === MOUSE_EVENT_TYPE.QUICK_SELECTION;
    }, [isMove, curBrushType]);

    const selectQuickSelection = useCallback(async () => {
        dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(MOUSE_EVENT_TYPE.QUICK_SELECTION));
    }, [dispatch]);

    const changeQuickSelectionActive = useCallback(
        value => {
            dispatch(FJActionBrushEditCommon.setAiMaskActive(value));
        },
        [dispatch],
    );

    return (
        <FJQuickSelectionBox
            isDisabled={isDisabled}
            quickSelectionActive={aiMaskActive}
            quickSelectionSelect={quickSelectionSelect}
            changeQuickSelectionActive={changeQuickSelectionActive}
            selectQuickSelection={selectQuickSelection}
            tipsTitle='auto-selection'
            tipsText='select-the-object-you-want-to-keep'
            tipsPreviewImg={FJConfig.quickSelectionTipImgUrl}
            tipsPreviewVideo={FJConfig.quickSelectionTipVideoUrl}
        />
    );
});

export default FJPhotoRemoveBgQuickSelectionBoxContainer;
